import React, {useState, useEffect} from 'react';
import { StyledConfigurationContainer, StyledFlexEnd, StyledIndexContainerDiv, StyledLeadContainer } from '../../../Components/Styled';
import DataGridTable from '../../../Components/DataGrid';
import { GridActionsCellItem, GridRowModes } from '@mui/x-data-grid';
import CancelIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import { handleRequestAddClientData, handleRequestGetAllClientData } from '../../../Store/Internationalise/action';
import { getRequestData, updateRequestData } from '../../../Utility/apiHelper';
import AutoCompleteComponent from '../../../Components/AutoCompleteComponenet';
import { Button, Stack, Tooltip, Typography } from '@mui/material';
import BiztantuLoader from '../../../Components/Loader';
import { REQUEST_GLOBALIZE_DATA } from '../../../Store/Internationalise/type';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import { handleValidateCodevalue } from '../../../Utility/constant';
import tableBodyicon from '../../../Assets/images/tablebody_edit.png';
import tableEditicon from '../../../Assets/images/tableheader_edit.png';
import LeadDialog from '../../../Components/LeadDialog';

const Internationalise = ({}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [dataGridData, setDatagridData] = useState([])
    const {enqueueSnackbar} = useSnackbar();
    const [isOpen, setopen] = useState(false);
    const dispatch = useDispatch();
    const [inputvalue, setInputvalue] = useState(null);
    const [requiredError, setRequiredError] = useState({
        code: false,
        value: false
    })
    const responseData = useSelector(state => state?.internationalise?.clientLabelData);
    const isLoadingProgress = useSelector(state => state?.internationalise?.isLoading);
   
    const currentUser = useSelector(state => state?.owner?.currentuser);
    
    useEffect(() => {
        if(currentUser?.client) {
            setDatagridData(responseData);
        }
      },[responseData])

      useEffect(()=>{
        handleSearchClient();
      },[currentUser])


    // useEffect(() => {
    //   if(lookupdetails?.systemlookup?.length > 0) {
    //     setDatagridData(lookupdetails?.systemlookup?.sort((a,b) => new Date(b?.updated).valueOf() - new Date(a?.updated).valueOf()));
    //   }
    // },[lookupdetails?.systemlookup])

    // useEffect(() => {
    //     dispatch(handleRequestGetAllClientData(currentUser?.company?.companyId));
    // },[])
  
    const handleDeleteLookup = (id) => () => {

    }

    const handleSaveClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };
  
    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    
    const handleCancelClick = (id) => () => {
        setRowModesModel({
          ...rowModesModel,
          [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    
        const editedRow = dataGridData.find((row) => row.id === id);
        if (editedRow.isNew) {
            setDatagridData(dataGridData.filter((row) => row.id !== id));
        }
      };

    const handleAddClick = () => {
        let id = "";
        setDatagridData((oldRows) => [{id, name: "", status: 'ACTIVE', sequence: "", isNew: true }, ...oldRows]);
        setRowModesModel((oldModel) => ({
          ...oldModel,
          [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
        }));
    };

 
    
    const systemlookupcodeColumn = [
        
        {
            field: 'actions',
            type: 'actions',
            headerName: <Tooltip title={handleValidateCodevalue(internationalise,'COMMON_ACTION')} ><img src={tableEditicon} style={{paddingTop: "18px"}} /></Tooltip>,
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
              const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
      
              if (isInEditMode) {
                return [
                  <GridActionsCellItem
                    icon={<CheckIcon />}
                    label={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                    className="textPrimary"
                    onClick={handleSaveClick(id)}
                  />,
                  <GridActionsCellItem
                    icon={<CancelIcon />}
                    label={handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                    className="textPrimary"
                    onClick={handleCancelClick(id)}
                    color="inherit"
                  />,
                ];
              }
      
              return [
                <GridActionsCellItem
                  icon={<img src={tableBodyicon} />}
                  label={handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                  className="textPrimary"
                  onClick={handleEditClick(id)}
                  color="inherit"
                />
                // <GridActionsCellItem
                //   icon={<DeleteIcon />}
                //   label="Edit"
                //   className="textPrimary"
                //   onClick={handleDeleteLookup(id)}
                //   color="inherit"
                // />,
              ];
            },
        },
        
        {
          field: 'code', 
          headerName: handleValidateCodevalue(internationalise,'CONF_I18_SEARCH_CODE'),
          flex: 1,
          editable: false
        },
        
        {
          field: 'value', 
          headerName: handleValidateCodevalue(internationalise,'CONF_I18_SEARCH_VALUE'),
          flex: 1,
          editable: true
        },
    ]

    const handleUpdateGlobalization = async(newdata) => {
        try {
            const payload = {
                "clientId": newdata?.id,
                "code": newdata?.code,
                "id": newdata?.id,
                "status": newdata?.status,
                "value": newdata?.value
            }
            

            dispatch({
                type: REQUEST_GLOBALIZE_DATA,
                payload: true
            })

            const {data} = await updateRequestData(payload, `${process.env.REACT_APP_BASE_URL}i18/update`);
            

            if(currentUser?.client?.id == payload?.clientId) {
                dispatch(handleRequestGetAllClientData(currentUser?.client?.id));
            }

            handleSearchClient();



        } catch(error) {
            dispatch({
                type: REQUEST_GLOBALIZE_DATA,
                payload: false
            })
            
        }
    }

    const handleUpdaterecord = async(newdata) => {

        //   if(!newdata?.value) {
        //       setRowModesModel({ ...rowModesModel, [newdata?.id]: { mode: GridRowModes.Edit } });
        //       enqueueSnackbar("Please enter system lookup name", {variant: "warning"});
        //   } else {
        setRowModesModel({ ...rowModesModel, [newdata?.id]: { mode: GridRowModes.View } });

        const payload = {
            "clientId": currentUser?.client?.id,
            "code": (newdata?.code|| "").trim(),
            "status": "ACTIVE",
            "value": (newdata?.value|| "").trim(),
        }

        await dispatch(handleRequestAddClientData(payload, enqueueSnackbar, internationalise,false));

    }
  
    const handleSearchClient = async() => {
        try {

            dispatch({
                type: REQUEST_GLOBALIZE_DATA,
                payload: true
            })
            const {data} = await getRequestData(`${process.env.REACT_APP_BASE_URL}i18?clientId=${currentUser?.client?.id}`);
            
            setDatagridData(data);

            dispatch({
                type: REQUEST_GLOBALIZE_DATA,
                payload: false
            })

        } catch(error) {
            dispatch({
                type: REQUEST_GLOBALIZE_DATA,
                payload: false
            })
        }
        
    }

    const handleAddCode = () => {
        setopen(true);
    }

    const handleSaveCode = async() => {
           const trimmedCode = (inputvalue?.code || "").trim();
           const trimmedValue = (inputvalue?.value || "").trim();

        if(trimmedCode && trimmedValue) {

            const codeddata = responseData?.find(item => item?.code ==trimmedCode);
            
            if(codeddata) {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"I18_CODE_ALREADY_EXIST_WARNING"), {variant: "warning"});
            } else {
                const payload = {
                    "clientId": currentUser?.client?.id,
                    "code": trimmedCode,
                    "status": "ACTIVE",
                    "value": trimmedValue
                }
    
                setopen(false);
    
                setInputvalue({
                    code: "",
                    value: ""
                });
    
                setRequiredError({
                    code: false,
                    value: false
                })
    
                await dispatch(handleRequestAddClientData(payload, enqueueSnackbar,internationalise, true));
    
            }
            
            
        } else {
            setRequiredError({
                code: true,
                value: true
            })
        }
    }

    const handlecancel = () => {
        setopen(false);
    }

    const handleOnChange = (event) => {
        
        const {name, value} = event?.target;
        
        setInputvalue({
            ...inputvalue,
            [name]: value
        })

    }

    return (
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
       
        <StyledConfigurationContainer>
            <Typography variant = "h6">
                {handleValidateCodevalue(internationalise,'CONF_I18_SEARCH_TITLE')}
            </Typography>
        </StyledConfigurationContainer>
        
            <StyledLeadContainer sx={{backgroundColor: "#F4F9FE",alignItems:"center"}}>
                <Stack display={"flex"} alignItems={"center"} className='table-header-search' padding={"10px"} spacing={2} width= "60%" direction="row" backgroundColor="white">
                                   
                    <AutoCompleteComponent
                        optionSet={[currentUser?.client]}
                        value={currentUser?.client}
                        disabled
                        label={handleValidateCodevalue(internationalise,'CONF_I18_SELECT_CLIENT')}
                        name="clientId"
                        sx={{width: "90%", margin: "0px 10px"}}

                    />
                </Stack>
                <StyledFlexEnd>
                    {(process.env.REACT_APP_DEFAULT_CLIENT ==  currentUser?.client?.id)&&
                        <Tooltip title={handleValidateCodevalue(internationalise,"TA_ADD_CODE")}>
                            <Button className='secondry-edit-btn' variant="outlined" onClick={handleAddCode}>{handleValidateCodevalue(internationalise,"TA_ADD_CODE")}</Button>
                        </Tooltip>
                    }
            </StyledFlexEnd>
                </StyledLeadContainer>
            <StyledIndexContainerDiv>
            <DataGridTable
                columns={systemlookupcodeColumn}
                marginTop='0px'
                height={"calc(100vh - 273px)"}
                dataGridData={dataGridData}
                clientId= {currentUser?.client?.id}
                rowModesModel = {rowModesModel}
                gridType = "Internationalise"
                handleAddClick = {handleAddClick}
                handleUpdateProduct = {handleUpdaterecord}
                // isLoading = {lookupdetails?.isSystemLoader}
                isCheckboxReq={false}
                handleAddCode = {handleAddCode}
            
            />
            </StyledIndexContainerDiv>
                {isOpen &&(
                   <LeadDialog
                        open={isOpen}
                        handleClose = {handlecancel}
                        title= {handleValidateCodevalue(internationalise,"ADD_I18_CODE_TITLE")}
                        size="sm"
                        btnlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                        handleSave={handleSaveCode}
                        alternateBtnLabel = {handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                    >

                    <StyledLeadContainer>
                        <TextFiledWithLabel
                            label={handleValidateCodevalue(internationalise,'CONF_I18_ADD_CODE')}
                            handleOnChange={handleOnChange}
                            value={inputvalue?.code}
                            name="code"
                            style={{width: "48%"}}
                            error={inputvalue?.code ? false : requiredError?.code}
                        />

                        <TextFiledWithLabel
                            label={handleValidateCodevalue(internationalise,'CONF_I18_ADD_VALUE')}
                            name="value"
                            value={inputvalue?.value}
                            handleOnChange={handleOnChange}
                            style={{width: "48%"}}
                            error={inputvalue?.value ? false : requiredError?.value}
                        
                        />
                    </StyledLeadContainer>
                    </LeadDialog>)
                }
        </BiztantuLoader>
        )
}

export default Internationalise;